import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress, Button, Tooltip } from '@material-ui/core';
import { Refresh as RefreshIcon } from '@material-ui/icons';
import { FHEContainer, FHEDivider, FHEMessageSender, ListNotesGit } from 'data/components';
import { Toastr } from 'data/common';
import FormIssue from './form';
import { getAllProjects } from '../../data/Projects/actions';
import { getNotes, createNote } from '../../data/Notes/actions';
import { getIssue, updateIssue } from '../../data/Issues/actions';

class IssueDetails extends PureComponent {
    static propTypes = {
        getAllProjects: PropTypes.func.isRequired,
        getNotes: PropTypes.func.isRequired,
        getIssue: PropTypes.func.isRequired,
        updateIssue: PropTypes.func.isRequired,
        createNote: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        projectsInit: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { projectsInit } = props;

        this.state = {
            loading: !projectsInit,
            issueLoading: true,
            noteLoading: true
        };
    }

    componentDidMount() {
        const { projectsInit } = this.props;

        if (!projectsInit) this.getAllProjects();
        this.refreshNotes();
        this.getIssue();
    }

    getAllProjects = () => {
        const { getAllProjects } = this.props;

        this.setState({ loading: true, error: null });

        getAllProjects()
            .then(() => this.setState({ loading: false, error: null }))
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    getIssue = () => {
        const { getIssue, match } = this.props;
        const { projectId, issueId } = match.params;

        this.setState({ issueLoading: true, error: null });

        getIssue(projectId, issueId)
            .then(data => {
                this.setState({
                    issueLoading: false,
                    error: null
                });
                return data;
            })
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
                this.setState({
                    issueLoading: false,
                    error: message
                });
                throw err;
            });
    };

    refreshNotes = () => {
        const { getNotes, match } = this.props;
        const { projectId, issueId } = match.params;

        this.setState({ noteLoading: true, error: null });

        getNotes(projectId, issueId)
            .then(data =>
                this.setState({
                    notes: data,
                    noteLoading: false,
                    error: null
                })
            )
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
                this.setState({
                    noteLoading: false,
                    error: message
                });
            });
    };

    createNote = message => {
        const { createNote, match } = this.props;
        const { projectId, issueId } = match.params;
        return createNote(projectId, issueId, message)
            .then(note => {
                Toastr.success(Translator.translate('ticketsgit.notes.actions.createNoteSuccess'));
                this.setState(prevState => {
                    const notes = [note, ...prevState.notes];
                    return {
                        notes
                    };
                });
                return note;
            })
            .catch(err => {
                Toastr.error(Translator.translate('ticketsgit.notes.actions.createNoteError'));
                throw err;
            });
    };

    updateIssue = formIssue => {
        const { updateIssue, match } = this.props;
        const { projectId, issueId } = match.params;

        return updateIssue(projectId, issueId, formIssue)
            .then(() => {
                Toastr.success(Translator.translate('ticketsgit.issues.actions.updateSuccess', formIssue.title));
                this.refreshNotes();
            })
            .catch(error => {
                Toastr.error(Translator.translate('ticketsgit.issues.actions.updateError'));
                throw error;
            });
    };
    renderChildren = () => {
        const { notes, noteLoading } = this.state;
        const { classes, profile, environment } = this.props;
        const createNoteRight = profile.get('admin') || profile.getIn(['user_rights', environment], []).includes('noteCreate');
        return (
            <Fragment>
                <FormIssue
                    type="update"
                    sendDataFunc={this.updateIssue}
                    renderOtherChildren={() => (
                        <Fragment>
                            <FHEDivider title={Translator.translate('ticketsgit.issues.table.noteTitle')} />
                            {createNoteRight && <FHEMessageSender sendMessageFunc={this.createNote} />}
                            <Tooltip title={Translator.translate('ticketsgit.notes.actions.refresh')} placement="top">
                                <div className={classes.refreshNotes}>
                                    <Button onClick={this.refreshNotes} style={{ color: 'grey' }}>
                                        {noteLoading ? <CircularProgress size={25} /> : <RefreshIcon />}
                                    </Button>
                                </div>
                            </Tooltip>
                            <ListNotesGit notes={notes} />
                        </Fragment>
                    )}
                />
            </Fragment>
        );
    };
    render() {
        const { loading, issueLoading, error } = this.state;
        return (
            <FHEContainer withBackIcon loading={loading || issueLoading} error={error} onClickFunc={this.getIssue} onRender={this.renderChildren} />
        );
    }
}

function mapStateToProps(state, props) {
    return {
        profile: state.data.user,
        projectsInit: state.environments[props.environment].data.Projects.get('initialized')
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    refreshNotes: {
        width: '100%',
        textAlign: 'center'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getAllProjects, getNotes, createNote, getIssue, updateIssue }, dispatch)
    )(withStyles(styles, { withTheme: true })(IssueDetails))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Issues/details.js